import eventbus from 'tiny-emitter/instance';
import { TYPE } from '@/constants';
import { DraggableMixin } from '@/core/mixins/DraggableMixin';
import { RotatableMixin } from '@/core/mixins/RotatableMixin';
import { SelectableMixin } from '@/core/mixins/SelectableMixin';
import Shapes from './index';

import Model from '../model';
import { enhanceObj } from '../enhanceObj';

export class Shape extends RotatableMixin(DraggableMixin(SelectableMixin(Model))) {
  constructor(params) {
    super(params);
    this.init(params.view);
  }

  get type() {
    return TYPE.SHAPE;
  }

  get typeTextual() {
    if (this.subtype === 'polygon') return 'Polygon';
    else if (this.subtype === 'rect') return 'Rectangle';
    else if (this.subtype === 'line') return 'Line';
    else if (this.subtype === 'circle') return 'Circle';
    return 'Shape';
  }

  setAttribute(name, value) {
    super.setAttribute(name, value);
    this.render();
    eventbus.emit('selection:delayedHistory', `${this.typeTextual} ${name} change`);
  }

  setStyle(name, value) {
    super.setStyle(name, value);
    this.render();
  }

  init() {
    this.view = this.canvas.group().addClass(this.type);
  }

  render() {
    this.shape.style(this.attributes.styles);
  }

  destroyView() {
    this.view.remove();
  }

  static fromJSON(params) {
    return Shapes.create(params.subtype, params);
  }

  destroy() {
    this.destroyView();
    eventbus.emit('unit:removed', this);
  }
}
